// extracted by mini-css-extract-plugin
export default {"landscape":"Landscape_landscape__-Z0+R","text":"Landscape_text__Or+FR"};